import './antButton.less';

import React, { ForwardedRef, forwardRef } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import { Button, ButtonProps, Dropdown, MenuProps } from 'antd';

export interface AntButtonProps extends ButtonProps {
	width?: number;
	items?: MenuProps;
}

export const AntButton = observer(
	forwardRef((props: AntButtonProps, ref: ForwardedRef<any>) => {
		const { style, className, width, items, ...restProps } = props;

		const classNames = React.useMemo(() => classnames(className, 'ceeview-ant-btn'), [className]);

		const styleActual = React.useMemo(() => {
			const result = { ...(style ?? {}) };

			if (width != null) {
				result.width = width + 'px';
			}

			return result;
		}, [style, width]);

		if (items) {
			return <Dropdown.Button ref={ref} menu={items} className={classNames} style={styleActual} {...restProps} />;
		}

		return <Button ref={ref} className={classNames} style={styleActual} {...restProps} />;
	}),
);
